module.exports = __webpack_public_path__ + "static/media/selants.ee98a54b.svg";